module.exports = __webpack_public_path__ + "media/images/direccion-3c1aebe1b84928eb9852f06a689d42cd.png";